import React from "react";
// import { useNavigate } from 'react-router-dom';
import './MintingPage.css';

// Add SVG component for Solana logo
const SolanaLogo = () => (
  <svg width="100" height="80" viewBox="0 0 397 311" fill="none" xmlns="http://www.w3.org/2000/svg" className="solana-logo">
    <path d="M64.6582 237.353C67.3406 234.674 71.0449 233.154 74.9315 233.154H390.626C396.822 233.154 399.92 240.592 395.518 244.993L332.238 308.246C329.556 310.925 325.852 312.445 321.965 312.445H6.27049C0.0747263 312.445 -3.02323 305.007 1.37863 300.606L64.6582 237.353Z" fill="url(#solana-gradient1)"/>
    <path d="M64.6582 3.7533C67.3406 1.07391 71.0449 -0.445557 74.9315 -0.445557H390.626C396.822 -0.445557 399.92 6.99232 395.518 11.3935L332.238 74.6466C329.556 77.326 325.852 78.8455 321.965 78.8455H6.27049C0.0747263 78.8455 -3.02323 71.4076 1.37863 67.0064L64.6582 3.7533Z" fill="url(#solana-gradient1)"/>
    <path d="M332.238 120.443C329.556 117.764 325.852 116.244 321.965 116.244H6.27049C0.0747263 116.244 -3.02323 123.682 1.37863 128.083L64.6582 191.336C67.3406 194.016 71.0449 195.535 74.9315 195.535H390.626C396.822 195.535 399.92 188.097 395.518 183.696L332.238 120.443Z" fill="url(#solana-gradient1)"/>
    <defs>
      <linearGradient id="solana-gradient1" x1="397" y1="0" x2="0" y2="312.445" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="#14F195"/>
        <stop offset="40%" stopColor="#5497D5"/>
        <stop offset="70%" stopColor="#8752F3"/>
        <stop offset="100%" stopColor="#9945FF"/>
      </linearGradient>
    </defs>
  </svg>
);

const MintingPage = () => {
  // const navigate = useNavigate();

  const handleNFTClick = () => {
    // Solana NFT minting is currently disabled
    // navigate('/create/solana-nft');
  };

  const handleCollectionClick = () => {
    // Solana collection minting is currently disabled
    // navigate('/create/solana-collection');
  };

  return (
    <div className="minting-page-wrapper">
      <div className="minting-container">
        <div className="minting-grid">
          <div className="minting-card disabled">
            <div className="card-tech-accent"></div>
            <div className="card-content">
              <div className="logo-container">
                <SolanaLogo />
              </div>
              <h2 className="card-title">Solana NFT</h2>
              <p className="card-description">
                Create Solana NFTs individually or within a collection.
              </p>
              <button onClick={handleNFTClick} className="minting-button disabled" disabled>
                COMING SOON
              </button>
              <div className="card-footer-line"></div>
            </div>
          </div>

          <div className="minting-card disabled">
            <div className="card-tech-accent"></div>
            <div className="card-content">
              <div className="logo-container">
                <SolanaLogo />
              </div>
              <h2 className="card-title">Solana Collection</h2>
              <p className="card-description">
                Create a standalone Solana collection without pre-minted NFTs.
              </p>
              <button onClick={handleCollectionClick} className="minting-button disabled" disabled>
                COMING SOON
              </button>
              <div className="card-footer-line"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MintingPage;